import React from "react";
import { cn } from "@/lib/utils";

/**
 * Textarea — multi-line text input primitive.
 *
 * Same design language as Input (see Input.jsx). Adds:
 *   • rows     — passthrough to native
 *   • resize   — 'none' | 'vertical' (default) | 'both'
 */

export const Textarea = React.forwardRef(function Textarea(
  {
    className,
    rows = 4,
    resize = "vertical",
    invalid = false,
    disabled = false,
    "data-testid": testId,
    ...rest
  },
  ref
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      data-testid={testId}
      className={cn(
        "block w-full rounded-[var(--ds-radius-md)] px-3 py-2 text-[14px]",
        "bg-[var(--ds-color-surface)] text-[var(--ds-color-ink)]",
        "placeholder:text-[var(--ds-color-ink-subtle)]",
        "border",
        invalid
          ? "border-[var(--ds-color-danger)]"
          : "border-[var(--ds-color-border-strong)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ds-color-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--ds-color-background)]",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        className
      )}
      style={{
        transitionDuration: "var(--ds-duration-fast)",
        resize,
      }}
      {...rest}
    />
  );
});

Textarea.displayName = "DSTextarea";

export default Textarea;
